module.exports = __webpack_public_path__ + "img/img11.68c99130.png";